import { getUrlParams, getObjProperty } from "@utilities/mrVueUtils";
import Vue from 'vue';

const state = {
  navItems: [
    { url: '/dashboard/welcome', text: 'Welcome' },
    //- subscriptions item gets inserted dynamically from mrVueApp using addMenuItem
    //- memberships item gets inserted dynamically from mrVueApp using addMenuItem
    { url: '/dashboard/shop', text: 'Shop' },
    { url: '/dashboard/account', text: 'Account' },
    { url: '/colorbar', text: 'Hair Color Bar', out: true },
    { url: '/dashboard/how-to', text: 'How To' },
    { url: '/refer', text: 'Refer a Friend', out: true },
    { url: '/blog', text: 'Blog', out: true },
  ],

  topNavSelected: '',
  topNavMobileNavOpen: false,

  searchOpen: false,

  windowData: {
    breakpoint: '',
    width: 0,
    height: 0,
    oldHeightOnScroll: 0,
    heightOnScroll: 0,
    scrollTop: 0,
    scrollBottom: 0,
    scrollDirection: 0,
    scrollDepth: 0,
    scrolled: false,
    noScroll: false,
    facebookBrowser: false,
    instagramBrowser: false,
    pinterestBrowser: false,
    isIOSApp: false,
    isIphone: false,
    isIpod: false,
    isIpad: false,
    isIosDevice: false,
    mobileNavHidden: false
  },

  MRConfig: null,
  isVueSSRApp: false,
  simpleHtml: false,
  urlParams: null,
  appHtml: '',
  isApp: false,
  headerClass: null,
  showHamburgerMenu: false,
  hideLogin: false,
  showNavs: true,
  showRCDishHorizontalNav: false,
  removeFaqsAndTerms: false,
  changeFaqsAndTerms: false,
  simpleFooter: false,
  breadcrumbs: null,
  experiments: {}
};

const getters = {
  showMensMenu(state, getters, rootState, rootGetters) {
    if (process.env.IS_BROWSER) {
      let show = false;
      let pathname = window.location.pathname;
      if (rootState.cms.cmsSettings.showMensMenu || (pathname == '/cart' && rootGetters['cart/cartContainsOnlyMensProducts'])) {
        show = true;
      }

      return show;
    } else {
      return false;
    }
  },

  urlParams() {
    return getUrlParams();
  },

  isMobile(state) {
    return getObjProperty(state, 'windowData.breakpoint') === 'mobile';
  },

  isDesktop(state) {
    return getObjProperty(state, 'windowData.breakpoint') === 'desktop';
  },

  breakpoint(state) {
    return getObjProperty(state, 'windowData.breakpoint');
  },

  showDirectMembership(state, getters, rootState, rootGetters) {
    // No active membership, no membership in cart, not rcc subscriber, (in experiment OR visitorType == Return Buyer
    let activeMembership = getObjProperty(rootGetters, 'customer/directMembership');
    let membershipInCart = getObjProperty(rootGetters, 'cart/cartContainsDirectMembership');
    let inExperiment = getObjProperty(state, 'experiments');
    let customerIsRcc = getObjProperty(rootState, 'customer.cdata.activeSubTypes.color_kit');
    let customerType = getObjProperty(rootState, 'customer.cdata.visitorType');

    return Boolean(!activeMembership && !membershipInCart && !customerIsRcc && (inExperiment["Limitless Plus"] == "B" || customerType == "Return Buyer"));
  },

  showDirectMembershipFooter(state, getters, rootState) {
     // show footer for people in experiment and return buyers that are not subscribers
     let customerType = getObjProperty(rootState, 'customer.cdata.visitorType');
     let customerIsRcc = getObjProperty(rootState, 'customer.cdata.activeSubTypes.color_kit');
 
     return Boolean(!customerIsRcc && customerType == "Return Buyer");
  }
};

const actions = {
  toggleSearch({ state, commit }) {
    commit('setSearchOpen', !state.searchOpen);
  }
};

const mutations = {
  addMenuItem(state, val) {
    //- make sure it exists, has url and is not in there already
    if (!val || !(val.url || val.method) || state.navItems.some(item => item.url == val.url)) {
      return;
    }

    let position = val.index || state.navItems.length;
    state.navItems.splice(position, 0, val);
  },

  removeMenuItem(state, name) {
    state.navItems = state.navItems.filter(item => item.text !== name);
  },

  setWindowData(state, [name, data]) {
    state.windowData[name] = data;
  },

  setTopNavSelected(state, val) {
    if (state.topNavSelected == val) {
      val = 0;
    }

    state.topNavSelected = +val;
  },

  setTopNavMobileNavOpen(state, val) {
    state.topNavMobileNavOpen = val;
  },

  setMRConfig(state, val) {
    state.MRConfig = val;
  },

  setIsVueSSRApp(state, val) {
    state.isVueSSRApp = val;
  },

  setSimpleHtml(state, val) {
    state.simpleHtml = !!val;
  },

  setUrlParams(state, val) {
    state.urlParams = val;
  },

  setSearchOpen(state, val) {
    state.searchOpen = Boolean(val);
  },

  setBrowserContext(state, newBrowserContext) {
    // https://stackoverflow.com/questions/61596158/vuex-mutation-best-practices-merging-state-with-payload
    Object.keys(newBrowserContext).forEach((key) => {
      Vue.set(state, key, newBrowserContext[key]);
    });
  },

  setAppHtml(state, appHtml) {
    state.appHtml = appHtml;
  },

  setBreadcrumbs(state, val) {
    state.breadcrumbs = val;
  },

  resetBreadcrumbs(state) {
    state.breadcrumbs = null;
  },
  
  setShowNavs(state, val) {
    state.showNavs = val;
  },

  setExperiments(state, val) {
    state.experiments = val;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
